<template>
  <div class="container-login">
    <div class="login-title">Login</div>
    <Form ref="formLogin" :model="formLogin" :rules="rulesForm" style="width:100%">
      <FormItem prop="login">
        <Input
          type="text"
          v-model="formLogin.login"
          placeholder="Login"
          size="large"
        >
        </Input>
      </FormItem>
      <FormItem prop="password">
        <Input
          type="password"
          v-model="formLogin.password"
          placeholder="Password"
          password
          size="large"   
        >
        </Input>
      </FormItem>
      <button class="btn" @click.prevent="handleSubmit('formLogin')">
        Continue
      </button>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLogin: {
        login: "",
        password: "",
      },
      rulesForm: {
        login: [
          {
            required: true,
            type: "string",
            message: "Please fill in the login.",
            trigger: "blur"
          },
        ],
        password: [
          {
            required: true,
            type: "string",
            message: "Please fill in the password.",
            trigger: "blur"
           
          },
         
        ]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
      
        if (valid) {
         const params = {};
         params["username"] = this.formLogin.login;
         params["password"] = this.formLogin.password;
         this.$store.dispatch('login', params)
         .then(() => {
           
           this.$router.push('/profile')
           this.$Message.success("Success");
         })
         .catch(err => {
           
            this.$Message.error({
              content:"Your login or password is incorrect. Please try again.",
              duration: 3
            });
         })

        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.container-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 430px;
  width: 100%;
  max-height: 700px;
  padding: 20px;
  background-color: #fff;
  background-image: none;
  box-shadow: 0px 0.1px 0.3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.2);
  .login-title {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 20px;
  }
  .btn {
    width: 100%;
    background: #FFE709;
    border-radius: 4px;
    outline: none;
    border: none;
    padding: 16px;
    text-transform: uppercase;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    cursor:pointer;
  }
}
</style>